import { isEmpty, get } from 'lodash';
import queryString from 'query-string';

/**
 * @type {function}
 * @desc Create encoded back route object (for the `backRoute` search query parameter).
 * @return Base64 encoded string.
 * @example
 * import * as backRoute from 'utils/backRoute';
 * const result = backRoute.encode( { pathname: '/', search: { memberId: '1' }, payload: { step: 1 } } );
 */
export const encode = ( { pathname, search = {}, payload = null } = {} ) => {

    // create JSON string
    const routeJSON = JSON.stringify( {
        pathname,
        search: queryString.stringify( search ),
        state: payload,
    } );

    return {
        backRoute: btoa( routeJSON ), // base64 encode
    };
};

/**
 * @type {function}
 * @desc Decode Base64 encoded back route string.
 * @return object for react router's `push` method.
 * @example
 * import * as backRoute from 'utils/backRoute';
 * const result = backRoute.decode( { location: this.props.location } );
 */
export const decode = ( location = {} ) => {
    if( ! isEmpty( get( location, 'state.backRoute' ) ) ) {
        try {

            // base64 decode backRoute
            const decodedValue = atob( get( location, 'state.backRoute' ) );

            // convert decoded value to an JavaScript object
            return JSON.parse( decodedValue );
        } catch( err ) {
            return null;
        }
    }

    return null;
};
